import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  padding: 0 49px 32px 29px;
  color: ${p => p.theme.colors.$nightRider};
`

Container.displayName = 'Container'
